module.exports = __webpack_public_path__ + "img/girl content.ab5a6c12.png";